/** Publika API:er som dokumenteras på /elpris-api, /prognos-api och i /llms.txt. */

/** Öppet, kostnadsfritt elpris-API (Supabase Edge Function). */
export const ELPRIS_API_BASE = `${import.meta.env["VITE_SUPABASE_URL"]}/functions/v1/elpris-api`;

/** Prognos-API för företag (kräver API-nyckel). */
export const PROGNOS_API_BASE = "https://elmarknad.se/api/public/v1/forecast";

export const ELPRIS_API_ENDPOINTS = [
  {
    path: "/v1/prices/{år}/{MM-DD}_{elområde}.json",
    example: "/v1/prices/2026/08-04_SE3.json",
    desc: "Alla spotpriser för ett specifikt datum och elområde.",
  },
  {
    path: "/v1/prices/today_{elområde}.json",
    example: "/v1/prices/today_SE3.json",
    desc: "Dagens priser (svensk tid).",
  },
  {
    path: "/v1/prices/tomorrow_{elområde}.json",
    example: "/v1/prices/tomorrow_SE3.json",
    desc: "Morgondagens priser, tillgängliga efter cirka kl. 13:00.",
  },
  {
    path: "/v1/areas.json",
    example: "/v1/areas.json",
    desc: "Lista över elområden SE1–SE4.",
  },
];

export const PROGNOS_API_ENDPOINTS = [
  {
    path: `${PROGNOS_API_BASE}/{elområde}/{horisont}`,
    example: `${PROGNOS_API_BASE}/SE3/7`,
    desc: "Spotprisprognos per dygn med dygnets högsta och lägsta timme samt periodens dyraste och billigaste dygn.",
  },
  {
    path: `${PROGNOS_API_BASE}/uncertainty/{elområde}/{horisont}`,
    example: `${PROGNOS_API_BASE}/uncertainty/SE3/14`,
    desc: "Samma data plus osäkerhetsintervall (low/high) för planering och riskanalys.",
  },
  {
    path: `${PROGNOS_API_BASE}/accuracy/{elområde}`,
    example: `${PROGNOS_API_BASE}/accuracy/SE3`,
    desc: "Uppmätt träffsäkerhet per horisont de senaste 30 dygnen.",
  },
  {
    path: `${PROGNOS_API_BASE}/accuracy/{elområde}/verified`,
    example: `${PROGNOS_API_BASE}/accuracy/SE3/verified`,
    desc: "Verifierad träffsäkerhet baserad på prognoser vi faktiskt levererat, jämförda mot utfall.",
  },
];
